// extracted by mini-css-extract-plugin
module.exports = {"linkPanel":"AreaCard_linkPanel__QIx6S","titleShort":"AreaCard_titleShort__A9dUc","titleLong":"AreaCard_titleLong__ASLVd"};